// extracted by mini-css-extract-plugin
export var back = "PickSlip-module--back--1c69e";
export var button = "PickSlip-module--button--68939";
export var buttons = "PickSlip-module--buttons--118d9";
export var cardWrapper = "PickSlip-module--cardWrapper--e216b";
export var clamp = "PickSlip-module--clamp--1aca8";
export var clickable = "PickSlip-module--clickable--1177f";
export var close = "PickSlip-module--close--1331a";
export var container = "PickSlip-module--container--911d5";
export var content = "PickSlip-module--content--6dd3d";
export var empty = "PickSlip-module--empty--316ab";
export var eventName = "PickSlip-module--eventName--e9bb5";
export var exoticTitle = "PickSlip-module--exoticTitle--43b91";
export var footer = "PickSlip-module--footer--21b5a";
export var header = "PickSlip-module--header--ff5d2";
export var hidden = "PickSlip-module--hidden--3f851";
export var icon = "PickSlip-module--icon--135c4";
export var iconButton = "PickSlip-module--iconButton--0ab1b";
export var info = "PickSlip-module--info--1359f";
export var isReviewing = "PickSlip-module--isReviewing--673a7";
export var label = "PickSlip-module--label--19e7f";
export var largeFooter = "PickSlip-module--largeFooter--c27df";
export var marketName = "PickSlip-module--marketName--c03f0";
export var numeric = "PickSlip-module--numeric--5c2c8";
export var outcomeIcon = "PickSlip-module--outcomeIcon--2079c";
export var panel = "PickSlip-module--panel--efd7e";
export var pickCount = "PickSlip-module--pickCount--deed2";
export var reuseBetsButton = "PickSlip-module--reuseBetsButton--2e867";
export var right = "PickSlip-module--right--9b66f";
export var scrollArea = "PickSlip-module--scrollArea--9e3cc";
export var selectionName = "PickSlip-module--selectionName--8a08b";
export var slash = "PickSlip-module--slash--2938a";
export var small = "PickSlip-module--small--30ede";
export var smallFooter = "PickSlip-module--smallFooter--92600";
export var tab = "PickSlip-module--tab--275e7";
export var tabList = "PickSlip-module--tabList--0ccb1";
export var tabListContainer = "PickSlip-module--tabListContainer--56238";
export var tabs = "PickSlip-module--tabs--8f75f";
export var title = "PickSlip-module--title--29025";
export var trash = "PickSlip-module--trash--2214b";
export var value = "PickSlip-module--value--00d8b";